import { useCallback } from 'react'
import classNames from 'classnames'
import TextInput from '../../../../components/form/TextInput'
import { useDispatch, useSelector } from 'react-redux'
import ErrorText from '../../../../components/form/ErrorText'
import { setName } from '../adGroupSlice'
import { trimValue } from '../../../../utils'
import PropTypes from 'prop-types'

const AdGroupName = ({ error }) => {
  const dispatch = useDispatch()
  const { name } = useSelector(state => state.ad.adGroup.form)
  const handleChange = useCallback(
    value => dispatch(setName(trimValue(value))),
    [dispatch]
  )
  return (
    <div className={classNames('area_item', { error })}>
      <strong className="subtit_box">광고그룹 이름</strong>
      <div className="cont_card">
        <div className="item_card">
          <TextInput
            placeholder="광고그룹 이름을 입력하세요."
            name="name"
            maxLength={50}
            value={name}
            onValueChange={handleChange}
            error={error}
          />
          <ErrorText error={error} tag="p" />
        </div>
      </div>
    </div>
  )
}
AdGroupName.propTypes = {
  error: PropTypes.string,
}

export default AdGroupName
